import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login/recover',
    loadChildren: () => import('./pages/login/recover/recover.module').then( m => m.RecoverPageModule)
  },
  {
    path: 'register/general',
    loadChildren: () => import('./pages/register/general/general.module').then( m => m.GeneralPageModule)
  },
  {
    path: 'register/menstruations',
    loadChildren: () => import('./pages/register/menstruations/menstruations.module').then( m => m.MenstruationsPageModule)
  },
  {
    path: 'calendar',
    loadChildren: () => import('./pages/calendar/tabs/tabs.module').then( m => m.TabsPageModule)
  }, 
  {
    path: 'fertilityCheck',
    loadChildren: () => import('./pages/fertilityCheck/tabs/tabs.module').then( m => m.TabsPageModule)
  }, 
  {
    path: 'fertilityCheck/test',
    loadChildren: () => import('./pages/fertilityCheck/test/test.module').then( m => m.TestPageModule)
  }, 
  {
    path: 'fertilityCheck/result/:id',
    loadChildren: () => import('./pages/fertilityCheck/result/result.module').then( m => m.ResultPageModule)
  },
  {
    path: 'fertility',
    loadChildren: () => import('./pages/fertility/fertility.module').then( m => m.FertilityPageModule) 
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then( m => m.AboutPageModule)
  },
  {
    path: 'menstruations',
    loadChildren: () => import('./pages/menstruations/menstruations.module').then( m => m.MenstruationsPageModule)
  },
  {
    path: 'health',
    loadChildren: () => import('./pages/health/health.module').then( m => m.HealthPageModule)
  },
  {
    path: 'health/weight',
    loadChildren: () => import('./pages/health/weight/weight.module').then( m => m.WeightPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/calendar/tabs/tabs.module').then( m => m.TabsPageModule)
  }, 
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'dailyNotes',
    loadChildren: () => import('./pages/dailyNotes/daily-notes.module').then( m => m.DailyNotesPageModule)
  },
  {
    path: 'pregnancyPrepare',
    loadChildren: () => import('./pages/pregnancyPrepare/tabs/tabs.module').then( m => m.TabsPageModule) 
    // loadChildren: () => import('./pages/pregnancyPrepare/pregnancy-prepare.module').then( m => m.PregnancyPreparePageModule)
  },

  { 
    path: 'pregnancyPrepare/historic',
    loadChildren: () => import('./pages/pregnancyPrepare/tabs/tabs.module').then( m => m.TabsPageModule) 
    // loadChildren: () => import('./pages/pregnancyPrepare/pregnancy-prepare.module').then( m => m.PregnancyPreparePageModule)
  },
  { 
    path: 'pregnancyPrepare/form',
    loadChildren: () => import('./pages/pregnancyPrepare/tabs/tabs.module').then( m => m.TabsPageModule) 
    // loadChildren: () => import('./pages/pregnancyPrepare/pregnancy-prepare.module').then( m => m.PregnancyPreparePageModule)
  },  {
    path: 'about',
    loadChildren: () => import('./pages/pregnancyPrepare/about/about.module').then( m => m.AboutPageModule)
  },
  {
    path: 'share',
    loadChildren: () => import('./pages/share/share.module').then( m => m.SharePageModule)
  },



 
  // {
  //   path: 'historic',
  //   loadChildren: () => import('./pages/pregnancyPrepare/historic/historic.module').then( m => m.HistoricPageModule)
  // },
  // {
  //   path: 'form',
  //   loadChildren: () => import('./pages/pregnancyPrepare/form/form.module').then( m => m.FormPageModule)
  // },



  // {
  //   path: 'main',
  //   loadChildren: () => import('./pages/calendar/main/main.module').then( m => m.MainPageModule)
  // },
  // {
  //   path: 'about',
  //   loadChildren: () => import('./pages/calendar/about/about.module').then( m => m.AboutPageModule)
  // },



 

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule {}


// import { NgModule } from '@angular/core';
// import {RouterModule, Routes } from '@angular/router';
// import {AppPreloadStrategy2Service } from './providers/app-preload-strategy2.service'; // não entendi esta abordagem

// const routes: Routes = [
//   {
//     path: '',
//     redirectTo: 'home',
//     pathMatch: 'full'
//   },
//   { 
//     path: 'home', 
//     loadChildren: './home/home.module#HomePageModule',
//     // data: {preload: true}
//   },
//   { 
//     path: 'list', 
//     loadChildren: './list/list.module#ListPageModule',
//     data: {preload: true}
//   },
// ];

// @NgModule({
//   imports: [RouterModule.forRoot(routes, {preloadingStrategy: AppPreloadStrategy2Service})],
//   exports: [RouterModule]
// })
// export class AppRoutingModule {}


// import { NgModule } from '@angular/core';
// import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

// const routes: Routes = [
//   {
//     path: '',
//     redirectTo: 'home',
//     pathMatch: 'full'
//   },
//   {
//     path: 'home',
//     loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
//   },
//   {
//     path: 'list',
//     loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
//   }
// ];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
//   ],
//   exports: [RouterModule]
// })
// export class AppRoutingModule {}



// Padrão Ionic
// import { NgModule } from '@angular/core';
// import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

// const routes: Routes = [
//   {
//     path: '',
//     redirectTo: 'home',
//     pathMatch: 'full'
//   },
//   {
//     path: 'home',
//     loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
//   },
//   {
//     path: 'list',
//     loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
//   }
// ];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
//   ],
//   exports: [RouterModule]
// })
// export class AppRoutingModule {}
